import { render } from "./post.vue?vue&type=template&id=3d14ec98"
import script from "./post.vue?vue&type=script&lang=ts"
export * from "./post.vue?vue&type=script&lang=ts"

import "./post.vue?vue&type=style&index=0&id=3d14ec98&lang=scss"
script.render = render

export default script